import apis from "../../core/apis.js";

class ContractorInvoiceResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  getAll(options) {
    return this.$resource(apis.contractorInvoice).get(options);
  }

  get(id) {
    return this.$resource(apis.contractorInvoice + id).get();
  }

  search(search = "") {
    return this.$resource(apis.contractorInvoice).get({ search });
  }

  post(item) {
    return this.$resource(apis.contractorInvoice).save(item);
  }
  getTypes(type) {
    return this.$resource(apis.contractorInvoice + "types").get(type);
  }
  update(id, item) {
    return this.$resource(apis.contractorInvoice + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }
}

export default ContractorInvoiceResource;



// WEBPACK FOOTER //
// ./src/resources/contractorInvoice/contractorInvoice.resource.js